import { HTTP_STATUS_CODE } from '@/constants/http-status'

class BaseException extends Error{
  constructor(message){
    super(message)
    this.code = ''
    this.message = message
    this.status = ''
    this.redirectPage = ''
    this.redirectParam = ''
  }
}
export class BussinessException extends BaseException{
  constructor(message, code){
    super(message)
    this.code = code
    this.status = HTTP_STATUS_CODE.BAD_REQUEST
  }
}

export class SystemException extends Error{
  constructor(){
    super('')
    this.status = HTTP_STATUS_CODE.INTERNAL_ERROR
    this.redirectPage = '/system-error'
  }
}

export class AuthenticationException extends Error{
  constructor(message){
    super(message)
    this.status = HTTP_STATUS_CODE.UNAUTHORIZED
    this.redirectPage = '/login'
  }
}

export class ForbiddenException extends Error{
  constructor(){
    super('')
    this.status = HTTP_STATUS_CODE.FORBIDDEN
    this.redirectPage = '/forbidden'
  }
}

export class NotFoundException extends Error{
  constructor(){
    super('')
    this.status = HTTP_STATUS_CODE.NOT_FOUND
    this.redirectPage = '/not-found'
  }
}

export class IdempotentException extends Error{
  constructor(){
    const message = '处理中，请勿重复提交'
    super(message)
    this.status = HTTP_STATUS_CODE.CONFLICT
  }
}

export class NetworkException extends Error{
  constructor(){
    super('')
    this.redirectPage = '/network-error'
    this.redirectParam = { type: 'network' }
  }
}
export class TimeoutException extends Error{
  constructor(){
    super('')
    this.redirectPage = '/network-error'
    this.redirectParam = { type: 'timeout' }
  }
}

